import styled from 'styled-components';

import { ColorLevelTreshold } from './utils';

export const gradientLevels: Record<ColorLevelTreshold, string> = {
  0: 'linear-gradient(315deg, #cecaca 14.64%, #8d8989 85.36%)',
  10: 'linear-gradient(323deg, #AE5E13 14.3%, #DFAD46 85.7%)',
  20: 'linear-gradient(323deg, #C22342 14.3%, #F2412D 85.7%)',
  30: 'linear-gradient(323deg, #366BF2 14.3%, #6B49DB 85.7%)',
  40: 'linear-gradient(84.1deg, #F8D3DA 0%, #B3A9F4 28.32%, #FBE9FB 54.01%, #4F94FD 100%)',
};

export const ManagerIdRoot = styled.div`
  background:
    var(
        --background,
        linear-gradient(var(--c-neutral-200), var(--c-neutral-200))
      )
      padding-box,
    var(--border, var(--c-neutral-100)) border-box;
`;
